import {Component, Vue} from 'vue-property-decorator';

import {_CALLS_STORE, CALLS_EVENTS, COMMAND_TYPE, SOURCE_END_CALL} from '@/components/calls/values/calls.values';
import KEYS from '@/values/keys';
import {TOAST_TYPES} from '@/plugins/ed-toast/values/ed-toast.values';

import $ from 'jquery';
import log from 'js-logger';
import moment from 'moment';
import {getOS, supportJitsi} from '@/components/calls/services/browser/browser-utils';

import {ClassesService} from '@/classes/services/classes.service';
import {CallsService} from '@/components/calls/services/calls.service';
import {APP_SOCKET_EVENTS, APP_SOCKET_MESSAGES_TYPE} from '@/core/values/app.values';
import {StartLocalMonitoring, StartRemoteMonitoring} from '../sip/sound.meter';
import {MEETINGS_STORE} from '@/meetings/store/meetings.store';
import {CALLS_STORE} from '@/components/calls/store/calls.store';

const {browser} = JitsiMeetJS.util;

/**
 * Control Calls with SIP.js
 */
@Component({})
export class CallsSipMixin extends Vue {

    //-- Handle errors
    public USER_NOT_IN_CALL: string =  '[COMMAND001]';
    public INCOGNITO_USER: string =  'Session.getOffer';
    public SIP_ERROR: string =  'SipError:';
    public MAX_RETRY_ATTEMPTS = 5;
    public retryCall : number = 0;
    public STUN_SERVER = 'stun:stun.l.google.com:19302';

    //-- Type Known Error
    public TYPE_ERROR_OVERCONSTRAINED :string =  'OVERCONSTRAINEDERROR';

    // public userAgent = null;
    public localSoundMeter = null;
    public remoteSoundMeter = null;

    // The number of times to attempt to reconnect to a WebSocket when the connection drops.
    public transportReconnectionAttempts : number = 999;

    // The time in seconds to wait between WebSocket reconnection attempts.
    public transportReconnectionTimeout : number = 3;
    private confReconect: any;
    private callReconect: any;

    //-- -----------------------------------------------------------------------------------------------------------------
    //-- Hooks
    beforeMount () {
        log.useDefaults();
    }

    //-- -----------------------------------------------------------------------------------------------------------------
    //-- Basic functions
    get isTeacher(): boolean {
        return this.$Auth.Store.isPublisher;
    }

    get currentUserId(): number {
        return this.$store.state.AuthStore.user.id;
    }

    get agent(): any {
        return this.$store.state.CallsStore.agent;
    }

    get currentMember(): any {
        return this.$store.state.CallsStore.meet.members.find(m => m.id === this.currentUserId)
    }

    get sip(){
        return this.$store.state.CallsStore.sip;
    }

    get call(){
        return this.$store.state.CallsStore.callConf;
    }

    get meet(){
        return this.$store.state.CallsStore.meet;
    }

    get classMembers(){
        return this.$store.state.CallsStore.meet.members;
    }

    get isIpad() {
        return /iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      }

    ua(prop:string, value:any){
        //this.$edEventBus.$emit(CALLS_EVENTS.UPDATE_AGENT, {prop, value});
        return this.$store.dispatch(CALLS_STORE.ACTIONS.UPDATE_AGENT,{prop, value});
    }

    sa(agent:any){
        //this.$edEventBus.$emit(CALLS_EVENTS.SET_AGENT, agent);
        return this.$store.dispatch(CALLS_STORE.ACTIONS.SET_AGENT,agent);
    }

    notExistAgent(){
        return Object.keys(this.$store.state.CallsStore.agent).length === 0;
    }
    existAgent(){
        return Object.keys(this.$store.state.CallsStore.agent).length !== 0;
    }


    async spUpdateMeet(key: string, value: any) {
        const obj: any = {};
        obj[key] = value;
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_MEET, obj);
    }

    async spUpdateMeetOnCache() {
        try {
            const meetUpdated = await CallsService.updateCurrentCall(this.meet);
            log.info('LEGO [spUpdateMeetOnCache] cache:', meetUpdated);
            this.spSetMeet(meetUpdated);
            return meetUpdated;
        } catch (error) {
            log.error('LEGO [spUpdateMeetOnCache] Error updating meet on cache:', error);
            throw error;
        }
    }
    spSetMeet(meet:any){
        this.$store.commit(_CALLS_STORE.MUTATIONS.SET_MEET, meet);
    }

    spUpdateSip(key:string, value:any){
        let obj = {};
        obj[key] = value
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_SIP, obj);
    }
    updateCallConfig(key:string, value:any){
        let obj = this.call;
        obj[key] = value
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_CALL_CONF, obj);
    }
    spAudioSrc(){
        let id = this.$store.state.CallsStore.audioSrc;
        return (id != null)? id : {deviceId: 'default', label:'labelDefault'};
    }
    spAudioOutput(){
        let id = this.$store.state.CallsStore.audioOutput;
        return (id != null)? id : {deviceId: 'default', label:'labelDefault'};
    }
    spVideoSrc(){
        let id = this.$store.state.CallsStore.videoSrc;
        return (id != null)? id : {deviceId: 'default', label:'labelDefault'};
    }
    spSetAudioSrc(device:any){
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_AUDIO_SRC_ID, device);
    }
    spSetAudioOutput(device:any){
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_AUDIO_OUTPUT_SRC_ID, device);
    }
    utcDateNow(){
        return moment().utc().format('YYYY-MM-DD HH:mm:ss UTC');
    }

    public isAvailable(type:string){
        if (type === 'audio'){
            return this.$store.state.CallsStore.deviceInfo.microphoneFound;
        } else if (type === 'video'){
            return this.$store.state.CallsStore.deviceInfo.videoFound;
        } else if (type === 'audiooutput'){
            return this.$store.state.CallsStore.deviceInfo.speakerFound;
        }
        return false;
    }

    spGetDevices(devType) {
        if (devType === 'audio') {
            return this.$store.state.CallsStore.deviceInfo.audioInputDevices;
        } else if (devType === 'video'){
            return this.$store.state.CallsStore.deviceInfo.videoInputDevices;
        } else if (devType === 'audiooutput'){
            return this.$store.state.CallsStore.deviceInfo.speakerDevices;
        }
    }

    spGetDevice(devType) {
        log.info ('LEGO [spGetDevice] ', devType)
        if (devType === 'audio') {
            return this.$store.state.CallsStore.audioSrc;
        } else if (devType === 'audiooutput'){
            return this.$store.state.CallsStore.audioOutput;
        } else if (devType === 'video'){
            return this.$store.state.CallsStore.videoSrc;
        }
    }

    spGetDeviceId(devType) {
        if (devType === 'audio') {
            return this.$store.state.CallsStore.audioSrcId;
        } else if (devType === 'audiooutput'){
            return this.$store.state.CallsStore.audioOutputId;
        } else if (devType === 'video'){
            return this.$store.state.CallsStore.videoSrcId;
        }
    }

    async spCheckDevices() {
        const deviceInfos = await navigator.mediaDevices.enumerateDevices();

        // Video
        const savedVideoDevice = this.spVideoSrc().deviceId;
        let videoDeviceFound = false;
        let videoFound = false;
        const videoInputDevices = [];
    
        // Audio Input
        const savedAudioDevice = this.spAudioSrc().deviceId;
        let microphoneFound = false;
        let audioDeviceFound = false;
        const audioInputDevices = [];
    
        // Audio Output
        const savedSpeakerDevice = this.spAudioOutput().deviceId;
        let speakerFound = false;
        let speakerDeviceFound = false;
        const speakerDevices = [];
    
        for (const deviceInfo of deviceInfos) {
            log.info('LEGO [spCheckDevices] Found Device (' + deviceInfo.kind + '): ', deviceInfo.label);
    
            // Check Devices
            if (deviceInfo.kind === 'audioinput') {
                microphoneFound = true;
                audioInputDevices.push(deviceInfo);
                if (savedAudioDevice !== 'default' && deviceInfo.deviceId === savedAudioDevice) {
                    audioDeviceFound = true;
                }
            } else if (deviceInfo.kind === 'audiooutput') {
                speakerFound = true;
                speakerDevices.push(deviceInfo);
                if (savedSpeakerDevice !== 'default' && deviceInfo.deviceId === savedSpeakerDevice) {
                    speakerDeviceFound = true;
                }
            } else if (deviceInfo.kind === 'videoinput') {
                videoFound = true;
                videoInputDevices.push(deviceInfo);
                if (savedVideoDevice !== 'default' && deviceInfo.deviceId === savedVideoDevice) {
                    videoDeviceFound = true;
                }
            } 
        }

        videoFound = false; // Video disabled for now
        const constraints: any = {
            audio: microphoneFound,
            video: videoFound,
        };
    
        if (microphoneFound) {
            constraints.audio = {
                deviceId: 'default',
                autoGainControl: true,
                echoCancellation: true,
                noiseSuppression: true,
                googAutoGainControl: true,
            };
            if (audioDeviceFound) {
                constraints.audio.deviceId = { exact: savedAudioDevice };
            }
        }
    
        if (videoFound) {
            constraints.video = { deviceId: 'default' };
            if (videoDeviceFound) {
                constraints.video.deviceId = { exact: savedVideoDevice };
            }
        }
    
        const deviceInfo = {
            // How to get the local tracks
            constraints,
    
            // Check if devices exist
            audioDeviceFound, // Exist mic
            microphoneFound, // Exist mic id
    
            videoFound, // Exist video
            videoDeviceFound, // Exist video id
    
            speakerFound, // Exist Speaker
            speakerDeviceFound, // Exist Speaker Id
    
            // Device Id - If Exist
            savedVideoDevice,
            savedAudioDevice,
            savedSpeakerDevice,
    
            // List of available devices
            videoInputDevices,
            audioInputDevices,
            speakerDevices,
        };
    
        log.info('LEGO [spCheckDevices] Update deviceInfo: ', deviceInfo);
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_DEVICE_INFO, deviceInfo);
        return deviceInfo;
    }

    //-- Load the mic at the moment.
    async spInitMediaDevices() {
        log.info('LEGO [spInitMediaDevices] Init ...');
        let localMicrophoneStream = new MediaStream();
    
        if (navigator.mediaDevices) {
            try {
                const info = await this.spCheckDevices();
                log.info('LEGO [spInitMediaDevices] info devices', info);
    
                const mediaStream = await navigator.mediaDevices.getUserMedia(info.constraints);
                const audioTrack = mediaStream.getAudioTracks().length >= 1 ? mediaStream.getAudioTracks()[0] : null;
    
                if (info.microphoneFound && audioTrack != null) {
                    localMicrophoneStream.addTrack(audioTrack);
                    (window as any).SettingsMicrophoneStream = localMicrophoneStream;
                    // window.SettingsMicrophoneSoundMeter = MeterSettingsOutput(localMicrophoneStream, 'Settings_MicrophoneOutput', 'width', 50);
                } else {
                    log.info('LEGO [spInitMediaDevices] No microphone devices found. Calling will not be possible.');
                }
    
                if (!info.speakerFound) {
                    log.info('LEGO [spInitMediaDevices] No speaker devices found, make sure one is plugged in.');
                }
            } catch (error) {
                log.warn('LEGO [spInitMediaDevices] Error initializing media devices:', error);
                throw error
            }
        } else {
            log.info('LEGO [spInitMediaDevices] navigator.mediaDevices not found!');
        }
    }

    //-- -----------------------------------------------------------------------------------------------------------------
    // Connection Utils

    spOnTransportConnected(){
        log.info('LEGO [onTransportConnected] init ... ');
        if (this.notExistAgent())return;
        log.info('LEGO [onTransportConnected] Connected ok ');

        // Reset the ReconnectionAttempts
        // this.userAgent.isReRegister = false;
        // this.userAgent.transport.attemptingReconnection = false;
        //this.userAgent.transport.ReconnectionAttempts = this.transportReconnectionAttempts;
        this.ua('isReRegister', false);
        this.ua('transport.attemptingReconnection', false);
        this.ua('transport.ReconnectionAttempts', this.transportReconnectionAttempts);

        // Auto start register
        if(this.agent.transport.attemptingReconnection == false && this.agent.registering == false){
            window.setTimeout( ()=>this.spRegister(), 500);
        } else{
            log.info('LEGO [onTransportConnected]: Register() called, but attemptingReconnection is true or registering is true')
        }

    }

    async spOnTransportConnectError(error){
        log.info('LEGO [onTransportConnectError] WebSocket Connection Failed:', error, this.agent);
        if (this.notExistAgent())return;

        // this.userAgent.isReRegister = false;
        this.ua('isReRegister', false);
        log.info('LEGO [onTransportConnectError] Unregister...');
        try{
            this.agent.registerer.unregister();
        } catch(e){
            log.warn('LEGO [onTransportConnectError] unregister ',e);
        }

        //-- TODO the reconnection is no enable at this moment.
        //-- If the user has ws problems we need to cut the call :S.
        //this.spReconnectTransport();

        //-- End call
        await this.spTeardownSession();
        await this.spCleanLocalCall();

        if(this.confReconect && this.callReconect){
            this.$EdModal.createConfirmationModal( {
                type: KEYS.EVENT_TYPES.WARNING,
                title: this.$i18n.t('common.callError'),
                body: this.$i18n.t('common.connErrorCall'),
                actionText: this.$i18n.t('common.reconnectCall'),
                action:  () => {
                    this.spStartCall(this.confReconect, this.callReconect);
                }
            });
        } else {
            this.$EdToast.create({
                msg: `${this.$t('common.connErrorCall')}`,
                type: TOAST_TYPES.WARNING,
                top: '3rem',
                timeout: 20000
            });
        }
    }


    spReconnectTransport(){
        if(this.notExistAgent()) return;

        this.ua('registering', false);
        //this.userAgent.registering = false;
        if(this.agent.transport && this.agent.transport.isConnected()){
            this.spOnTransportConnected();
            return;
        }
        log.info('LEGO [spReconnectTransport] Reconnect Transport...');

        window.setTimeout(()=>{
            log.info('LEGO [spReconnectTransport] ReConnecting to WebSocket...');
            if(this.agent.transport && this.agent.transport.isConnected()){
                this.spOnTransportConnected();
                return;
            } else {
                this.ua('transport.attemptingReconnection', true);
                //this.userAgent.transport.attemptingReconnection = true
                this.agent.reconnect().catch((error)=>{
                    this.ua('transport.attemptingReconnection', false);
                    //this.userAgent.transport.attemptingReconnection = false
                    log.warn('LEGO [spReconnectTransport] Failed to reconnect', error);
                    this.spReconnectTransport();
                });
            }
        }, this.transportReconnectionTimeout * 1000);

        log.info('LEGO [spReconnectTransport] Waiting to Re-connect...', this.transportReconnectionTimeout, 'seconds. Attempt remaining: ', this.agent.transport.ReconnectionAttempts);
        this.ua('transport.ReconnectionAttempts', this.agent.transport.ReconnectionAttempts - 1);
        //this.agent.transport.ReconnectionAttempts = this.agent.transport.ReconnectionAttempts - 1;
    }

    //-- -----------------------------------------------------------------------------------------------------------------
    // Register functions

    spRegister() {
        if (this.notExistAgent()) return;
        if (this.agent.registering == true) return;
        if (this.agent.isRegistered()) return;
        let opts = {
            requestDelegate: {
                onReject: (sip) => {
                    log.info('LEGO [spRegister] onReject: ', sip);
                    // this.userAgent.registering = false;
                    this.ua('registering', false);
                }
            }
        }
        log.info('LEGO [spRegister] Sending Registration...', this.agent);
        this.ua('registering', true);
        //this.userAgent.registering = true
        this.agent.registerer.register(opts);
    }

    spOnUnregistered() {
        log.info('LEGO [spOnUnregistered] Init.');
        if(this.existAgent()){
            if(this.agent.registrationCompleted) {
                log.info('LEGO [spOnUnregistered] Unregistered !!!');
            }
            this.ua('isReRegister', false);
            //this.userAgent.isReRegister = false;
        }
    }

    /**
     * Client registered
     */
    spRegistered(){
        if(this.agent.isReRegister) {
            log.info('LEGO [spRegistered] ReRegistered!');
        }else{
            log.info('LEGO [spRegistered] Registered!');
        }
        this.ua('registrationCompleted', true);
        //this.userAgent.registrationCompleted = true;
        this.ua('registering', false);
        // this.userAgent.registering = false;
        this.ua('isReRegister', true);
        // this.userAgent.isReRegister = true;
    }

    //-- -----------------------------------------------------------------------------------------------------------------
    // Main functions

    /**
     * Create call client
     */
    async spCreateUserAgent() {
        log.info('LEGO [spCreateUserAgent] Init ...', ('sip:' + this.call.sipUsername + '@' + this.call.sipDomain));
        
        const iceServers = [ { urls: this.STUN_SERVER } ];
        const options: any = {
            uri: SIP.UserAgent.makeURI('sip:' + this.call.sipUsername + '@' + this.call.sipDomain),
            transportOptions: {
                server: this.call.wssServer,
                traceSip: false,
                connectionTimeout: 15, // seconds
                keepAliveInterval: 5
            },
            sessionDescriptionHandlerFactoryOptions: {
                peerConnectionConfiguration: {
                    rtcConfiguration: { iceServers },
                    iceCandidatePoolSize: 0,
                    bundlePolicy: this.isIpad ? 'max-compat' : 'balanced', // SDP Media Bundle: max-bundle | max-compat | balanced
                    iceServers
                },
                iceGatheringTimeout: 5000, // Set amount of time in milliseconds to wait for the ICE/STUN server
                alwaysAcquireMediaFirst: true,
            },
            contactName: '',
            displayName: 'default',
            authorizationUsername: this.call.sipUsername,
            authorizationPassword: this.call.sipPassword,
            hackIpInContact: true,
            userAgentString: 'Eduac Client (SipJs - 0.20.0) ' + window.navigator.userAgent,
            autoStart: false,
            autoStop: true,
            register: false,
            noAnswerTimeout: 120,
            contactParams: {
                transport: 'wss'
            }
        };
    
        log.info('LEGO [spCreateUserAgent] Creating User Agent: ', options);
        const userAgent = new SIP.UserAgent(options);
    
        userAgent.isRegistered = function () {
            return userAgent && userAgent.registerer && userAgent.registerer.state === SIP.RegistererState.Registered;
        };
        userAgent.sessions = userAgent._sessions;
        userAgent.registrationCompleted = false;
        userAgent.registering = false;
        userAgent.transport.ReconnectionAttempts = this.transportReconnectionAttempts;
        userAgent.transport.attemptingReconnection = false;
        this.sa(userAgent);
    
        log.info('LEGO [spCreateUserAgent] Creating User Agent... Done');
        userAgent.transport.onConnect = () => this.spOnTransportConnected();
        userAgent.transport.onDisconnect = async (error) => {
            log.info('LEGO [onTransportDisconnected] Init::', error);
            if (error) {
                await this.spOnTransportConnectError(error);
            } else {
                if (this.agent) {
                    this.ua('isReRegister', false);
                }
                log.info('LEGO [onTransportDisconnected] Disconnected from Web Socket!');
            }
        };
    
        const registererOptions = {
            expires: 300, // Registration expiry time (in seconds)
            extraHeaders: [],
            extraContactHeaderParams: []
        };
    
        log.info('LEGO [spCreateUserAgent] Creating Registerer...', registererOptions);
        userAgent.registerer = new SIP.Registerer(userAgent, registererOptions);
        userAgent.registerer.stateChange.addListener((newState) => {
            log.info('LEGO [spCreateUserAgent] User Agent Registration State:', newState);
            switch (newState) {
                case SIP.RegistererState.Registered:
                    this.spRegistered();
                    break;
                case SIP.RegistererState.Unregistered:
                    void this.spOnUnregistered();
                    break;
            }
        });
    
        log.info('LEGO [spCreateUserAgent] Creating User Agent... Done');
        log.info('LEGO [spCreateUserAgent] User Agent Connecting to WebSocket...');
        this.sa(userAgent);
        await userAgent.start();
    }

    /**
     * onDeviceChange - recalculate the default device
     * Ej: When you connect headphones
     */
    async spOnDeviceChange() {
        log.info('LEGO [spOnDeviceChange] Change Devices (a device was connected or disconnected)')
        const session = this.$store.state.CallsStore.sip.session;
        if (!session || !session.data) return;
        if (this.isOnCall()) return;

        try {
            const info = await this.spCheckDevices();
            log.info('LEGO [spOnDeviceChange] Current Devices:', info);
    
            //-- Handle change of Mic (AudioInput Device)
            if (info.microphoneFound) {
                if (!info.audioDeviceFound) { // The device was removed - set the default device
                    const trackToSet = this.spGetDevices('audio')[0];
                    log.info('LEGO [spOnDeviceChange] Not found AudioInput - set with:', trackToSet)
                    this.spChangeLocalAudioInputDevice(trackToSet);
                }
            } else {
                //-- Clean device data
                this.spSetAudioSrc(null);
            }
    
            //-- Handle change of Speakers (AudioOutput Device)
            if (info.speakerFound) {
                // The device was removed - set the default device
                if (!info.speakerDeviceFound) {
                    const trackToSet = this.spGetDevices('audiooutput')[0];
                    log.info('LEGO [spOnDeviceChange] Not found Speaker - set with:', trackToSet)
                    this.spChangeLocalAudioOutputDevice(trackToSet);
                }
            } else {
                //-- Clean device data
                this.spSetAudioOutput(null);
            }
    
            log.info('LEGO [spOnDeviceChange] OK !!!');
        } catch (error) {
            log.warn('LEGO [spOnDeviceChange] Error !!!', error);
        }
    }
    //------------------------------------------------------------------------------------------------------------------
    //-- Main Functions
    async spCleanLocalCall() {
        if (navigator.mediaDevices.ondevicechange) {
            navigator.mediaDevices.ondevicechange = null;
        }
        navigator.mediaDevices.ondevicechange = this.spOnDeviceChange;
        //-- Sound meter
        this.localSoundMeter = null;
        this.remoteSoundMeter = null;
        
        //-- Clean sip protocol
        if (this.existAgent()) {
            this.agent.stop();
        }

        //-- Clean Local Tracks
        $('#call_container_audio').html('');

        //-- Clean Call Store
        this.$store.commit(_CALLS_STORE.MUTATIONS.CLEAN_CALL);
    
        //-- Clean local streams (Audio)
        let lwindow: any = window;
        log.info('LEGO [cleanLocalControls] Init ...');
        try {
            if (lwindow.SettingsMicrophoneStream) {
                let tracks = lwindow.SettingsMicrophoneStream.getTracks();
                tracks.forEach((track) => track.stop());
            }
        } catch (e) {
            log.warn('LEGO [cleanLocalControls] Error SettingsMicrophoneStream', e);
        }
        lwindow.SettingsMicrophoneStream = null;
    
        try {
            if (lwindow.SettingsMicrophoneSoundMeter) {
                lwindow.SettingsMicrophoneSoundMeter.stop();
            }
        } catch (e) {
            log.warn('LEGO [cleanLocalControls] Error SettingsMicrophoneSoundMeter', e);
        }
        lwindow.SettingsMicrophoneSoundMeter = null;
    }

    async spStartCall(conf: any, currentCall: any) {
        try {
            this.spShowProcessing();
            await this.spCleanLocalCall();
            this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_CALL_CONF, conf);
            log.info('LEGO [spStartCall] starting: [', conf, ']');

            await this.spInitMediaDevices();
            await this.spCreateUserAgent();
            const mics = this.spGetDevices('audio');
            if (mics && mics.length > 0) {
                log.info('LEGO [spStartCall] Set Mic:', mics[0]);
                this.spSetAudioSrc(mics[0]);
            } else {
                throw new Error('No microphone devices not found. Calling will not be possible.');
            }   

            const speakers = this.spGetDevices('audiooutput');
            if (speakers && speakers.length > 0) {
                log.info('LEGO [spStartCall] Set Speaker:', speakers[0]);
                this.spSetAudioOutput(speakers[0]);
            }

            await this.spAudioCall(conf.extensionId);
            await this.spInitSoundMeter();
    
            if (currentCall.exists) {
                this.spSetMeet(currentCall);
                log.info('LEGO [spStartCall] - EXITS:', currentCall);
                await this.spUpdateLocalStateFromCache();
            } else {
                log.info('LEGO [spStartCall] - NO EXITS', currentCall);
                await this.spInitCallInCache(conf);
            }
    
            if (currentCall.exists) {
                const found = this.classMembers.find(m=>m.id === this.currentUserId)
                if (this.meet.muted){  //-- New students on call before mute all
                    if (this.meet.userId!=this.currentUserId && !found.muted) {
                        return this.mute(this.currentUserId, true);
                    }
                }else{ //-- Remove mute from new user on call
                    if (found.muted && this.meet.userId!=this.currentUserId && !found.wasMuted) {
                        return this.mute(this.currentUserId, false);
                    }
                }
            }

            //-- Clean timer
            this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_LOCAL_TIME, null);

            //-- Notify the students that the call has started.
            log.info('LEGO [spStartCall] send event - socket (START_CALL): ', conf.meetingId, conf.classId);
            this.$EdSocket.emit(APP_SOCKET_EVENTS.TEACHER_START_CALL_REQUEST, {
                username: this.$store.state.AuthStore.user.fullName,
                messageType: APP_SOCKET_MESSAGES_TYPE.START_CALL,
                content: conf.meetingId,
                topicId: conf.classId
            });
    
            log.info('LEGO [spStartCall] - started OK !!!');
            this.retryCall = 0;
            await this.$store.dispatch(MEETINGS_STORE.ACTIONS.FETCH_LIVE_MEETINGS);
        } catch (error) {
            //let isIncognito = error && error.message && error.message.includes(this.INCOGNITO_USER);
            const parsedError = this.parseStartError(error);
            log.warn('LEGO [spStartCall] - ERROR: [', error, '][', parsedError, ']');
    
            if (parsedError?.startsWith(this.TYPE_ERROR_OVERCONSTRAINED)) {
                const waitToRecover = new Promise<void>((res) =>
                    setTimeout(() => {   res();
                        log.warn('LEGO [spStartCall] - ERROR: wait OverconstrainedError.');
                    }, 1000));
    
                await this.spShowProcessing();
                await waitToRecover;
                await this.spTeardownSession();
    
                if (++this.retryCall < this.MAX_RETRY_ATTEMPTS) {
                    log.warn('LEGO [spStartCall] RetryCall: ', this.retryCall);
                    await this.spStartCall(conf, currentCall);
                } else {
                    log.warn('LEGO [spStartCall] call attempt exceeded: ', this.retryCall);
                    await this.spCleanLocalCall();
                }
            } else {
                this.showModal(this.$i18n.t('errors.errorConnCallServer', { reason: error }), KEYS.EVENT_TYPES.WARNING);
                await this.spTeardownSession();
                await this.spCleanLocalCall();
            }
        } finally {
            this.spHideProcessing();
        }
    
        this.confReconect = conf;
        this.callReconect = currentCall;
    }

    parseStartError (error:any){
        if (typeof error === 'string' || error instanceof String){
            return error;
        }else if (typeof error === 'object' && !Array.isArray(error) && error !== null){
            return error.toString().toUpperCase();
        }
        return '';
    }

    /**
     * Start cache with the meeting
     * @param conf
     */
    async spInitCallInCache(conf:any){
        let classMembers = await ClassesService.getTeachersByClassId(conf.classId)
        let members = classMembers.map(p=> {
            return {
                id: p.person.id,
                userName: p.person.userId,
                type: p.type,
                fullName: p.person.fullName,
                muted: false,
                kickouted: false
            }
        });

        log.info('LEGO [spInitCallInCache] members: ', members);
        this.spUpdateMeet('members', members);
        this.spUpdateMeet('muted', false);
        this.spUpdateMeet('locked', false);
        this.spUpdateMeet('classId', conf.classId);
        this.spUpdateMeet('className', conf.className);
        this.spUpdateMeet('meetingId', conf.meetingId);
        this.spUpdateMeet('userId', conf.userId);
        this.spUpdateMeet('callStartDate', conf.startCall);

        return await this.spUpdateMeetOnCache();
    }

    /**
     * Start cache with the meeting
     * @param conf
     */
    async spUpdateLocalStateFromCache() {
        if (this.classMembers) {
            const found = this.classMembers.find(m => m.id === this.currentUserId);
            log.info('LEGO [spUpdateLocalStateFromCache] members: ', found, this.meet.muted);
    
            if (found?.muted) {
                log.info('LEGO [spUpdateLocalStateFromCache] members: TRUE');
                await this.spMuteMic(true);
            } else {
                log.info('LEGO [spUpdateLocalStateFromCache] members: FALSE');
                await this.spMuteMic(false);
            }
        }
    }

    /**
     * Start sound monitoring
     */
    async spInitSoundMeter() {
        let session = this.sip['SipSession'];
        log.info('LEGO [spInitSoundMeter] Init ...', this.sip);
        if (session) {
            log.info('LEGO [spInitSoundMeter] StartMonitoring ...');
            try {
                this.localSoundMeter = await StartLocalMonitoring(session);
                this.remoteSoundMeter = await StartRemoteMonitoring(session);
            } catch (error) {
                log.warn('LEGO [spInitSoundMeter] Error initializing sound meters:', error);
                throw error
            }
        }
    }

    /**
     * Make audio call
     * @param dialledNumber
     * @param extraHeaders
     */
    async spAudioCall(dialledNumber: string) {
        log.info('LEGO [spAudioCall] Init ...');
        if (this.notExistAgent()) return;
    
        if (this.$store.state.CallsStore.deviceInfo.microphoneFound === false) {
            log.info('LEGO [spAudioCall] No local microphone found!');
            return;
        }
        const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
        log.info('LEGO [spAudioCall] supportedConstraints:', supportedConstraints);
    
        const spdOptions: any = {
            earlyMedia: true,
            alwaysAcquireMediaFirst: true,
            sessionDescriptionHandlerOptions: {
                constraints: {
                    audio: { deviceId: 'default' },
                    video: false,
                },
            },
        };
    
        // Configure Audio
        const currentAudioDevice = this.spAudioSrc().deviceId;
        if (currentAudioDevice !== 'default') {
            const mics = this.spGetDevices('audio');
            const confirmedAudioDevice = mics.some((mic) => mic.deviceId === currentAudioDevice);
    
            if (confirmedAudioDevice) {
                spdOptions.sessionDescriptionHandlerOptions.constraints.audio.deviceId = { exact: currentAudioDevice }
            } else {
                log.info('LEGO [spAudioCall] - The audio device you used before is no longer available, default settings applied.');
                this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_AUDIO_SRC_ID, 'default');
            }
        }
        // Add additional Constraints
        if (supportedConstraints.autoGainControl) {
            spdOptions.sessionDescriptionHandlerOptions.constraints.audio.autoGainControl = true;
        }
        if (supportedConstraints.echoCancellation) {
            spdOptions.sessionDescriptionHandlerOptions.constraints.audio.echoCancellation = true;
        }
        if (supportedConstraints.noiseSuppression) {
            spdOptions.sessionDescriptionHandlerOptions.constraints.audio.noiseSuppression = true;
        }
    
        //--  Invite
        let _this = this;
        let startTime = moment.utc();
        log.info('LEGO [spAudioCall] INVITE (audio): ' + dialledNumber + '@' + this.call.sipDomain);
        let targetURI = SIP.UserAgent.makeURI('sip:' + dialledNumber + '@' + this.call.sipDomain);
        this.sip['SipSession'] = new SIP.Inviter(this.agent, targetURI, spdOptions);
        this.sip['SipSession'].data = {}
        this.sip['SipSession'].data.line = 1;
        this.sip['SipSession'].data.calldirection = 'outbound';
        this.sip['SipSession'].data.dst = dialledNumber;
        this.sip['SipSession'].data.callstart = startTime.format('YYYY-MM-DD HH:mm:ss UTC');
        this.sip['SipSession'].data.VideoSourceDevice = null;
        this.sip['SipSession'].data.AudioSourceDevice = this.spAudioSrc().deviceId;
        this.sip['SipSession'].data.AudioOutputDevice = this.spAudioOutput().deviceId;
        this.sip['SipSession'].data.terminateby = 'them';
        this.sip['SipSession'].data.withvideo = false;
        this.sip['SipSession'].data.earlyReject = false;
        this.sip['SipSession'].isOnHold = false;
        this.sip['SipSession'].delegate = {
            onBye: function(sip){
                log.info('LEGO [spAudioCall] [onBye] ', sip);
                _this.spOnSessionReceivedBye(sip);
            },
            onMessage: function(sip){
                log.info('LEGO [spAudioCall] [onMessage] ', sip);
                _this.spOnSessionReceivedMessage(sip);
            },
            onInvite: function(sip){
                log.info('LEGO [spAudioCall] [onInvite] ', sip);
                _this.spOnSessionReinvited(sip);
            },
            onSessionDescriptionHandler: function(sdh, provisional){
                log.info('LEGO [spAudioCall] [onSessionDescriptionHandler] ', {sdh, provisional});
                _this.spOnSessionDescriptionHandlerCreated(sdh);
            }
        }
    
        const inviterOptions = {
            requestDelegate: {
                onTrying: (sip) => {
                    log.info('LEGO [requestDelegate] [onTrying] ', sip);
                },
                onProgress: (sip) => {
                    log.info('LEGO [requestDelegate] [onProgress] ', sip);
                    this.spOnInviteProgress(sip);
                },
                onRedirect: (sip) => {
                    log.info('LEGO [requestDelegate] [onRedirect] ', sip);
                },
                onAccept: async (sip) => {
                    log.info('LEGO [requestDelegate] [onAccept] ', sip);
                    await this.spOnInviteAccepted(false, sip);
                },
                onReject: async (sip) => {
                    log.info('LEGO [requestDelegate] [onReject] ', sip);
                    this.spOnInviteRejected(sip);
                },
            },
        };
    
        log.info('LEGO [spAudioCall] execute invitation: ', inviterOptions);
        this.spUpdateSip('session', this.sip['SipSession']);
    
        try {
            await this.sip['SipSession'].invite(inviterOptions);
        } catch (error) {
            log.error('LEGO [spAudioCall] Error sending invitation:', error);
            throw error;
        }
    }

    async spOnInviteAccepted(includeVideo: boolean, response: any): Promise<void> {
        try {
            let session = this.sip['SipSession'];
            if (session.data.earlyMedia) {
                session.data.earlyMedia.pause();
                session.data.earlyMedia.removeAttribute('src');
                session.data.earlyMedia.load();
                session.data.earlyMedia = null;
            }
            let startTime = moment.utc();
            session.data.startTime = startTime;
            session.isOnHold = false;
            session.data.started = true;
    
            log.info('LEGO [spOnInviteAccepted] EMIT CALL_STARTED true !!!', response);
            this.$edEventBus.$emit(CALLS_EVENTS.CALL_STARTED, { origin: 'spOnInviteAccepted', status: true });
        } catch (error) {
            log.error('LEGO [spOnInviteAccepted] Error during invite acceptance:', error);
            try {
                await this.spTeardownSession();
                await this.spCleanLocalCall();
            } catch (cleanupError) {
                log.error('LEGO [spOnInviteAccepted] Error during cleanup:', cleanupError);
            }
            throw error;
        }
    }
    async spOnInviteRejected(response: any): Promise<void> {
        try {
            log.info('LEGO [spOnInviteRejected] INVITE Rejected:', response.message.reasonPhrase);
        let session = this.sip['SipSession'];
            session.data.terminateby = 'them';
            session.data.reasonCode = response.message.statusCode;
            session.data.reasonText = response.message.reasonPhrase;

            await this.spTeardownSession();
            await this.spCleanLocalCall();
    
            log.info('LEGO [spOnInviteRejected] EMIT CALL_STARTED false !!!');
            this.$edEventBus.$emit(CALLS_EVENTS.CALL_STARTED, {
                origin: 'spOnInviteRejected',
                status: false,
                reason: `${response.message.statusCode} - ${response.message.reasonPhrase}`,
            });
        } catch (error) {
            log.error('LEGO [spOnInviteRejected] Error during invite rejection handling:', error);
            throw error;
        }
    }

    spOnInviteProgress(response){
        log.info('LEGO [spOnInviteProgress] Call Progress:', response.message.statusCode);

        // Provisional 1xx
        // response.message.reasonPhrase
        if(response.message.statusCode == 180){
            //- Add some ringing sound
            log.info('LEGO [spOnInviteProgress] ringing :', response.message.statusCode);
        } else if(response.message.statusCode === 183){
            log.info('LEGO [spOnInviteProgress] onInvitedProgress (statusCode === 183) ', response.message.reasonPhrase);
        }else {
            // 181 = Call is Being Forwarded
            // 182 = Call is queued (Busy server!)
            // 199 = Call is Terminated (Early Dialog)
            log.info('LEGO [spOnInviteProgress] onInvitedProgress: (else) ', response.message.reasonPhrase );
        }
    }

    /**
     * Gets remote tracks
     */
    public mediaStream: MediaStream;
    async spOnTrackAddedEvent(event: any): Promise<void> {
        log.info('LEGO [onTrackAddedEvent] EVENT: ', event)
        
        let session = this.$store.state.CallsStore.sip.session;
        let pc = session.sessionDescriptionHandler.peerConnection;
        let remoteAudioStream = new MediaStream();
        this.mediaStream = event.streams[0];

        pc.getTransceivers().forEach(function (transceiver) {
            // Add Media
            let receiver = transceiver.receiver;
            if(receiver.track){
                if(receiver.track.kind == 'audio'){
                    log.info('LEGO [onTrackAddedEvent] Adding Remote Audio Track');
                    remoteAudioStream.addTrack(receiver.track);
                }
            } 
        });
        // Attach Audio
        if(remoteAudioStream.getAudioTracks().length >= 1){
            $('#call_container_audio').html('');
            $('#call_container_audio').append(`
                <div style='height: 0; width: 0; overflow: hidden; visibility: hidden'>
                    <audio controls autoplay playsinline id='remote-audio'></audio>
                </div>`);

            let remoteAudio = $('#remote-audio').get(0);
            remoteAudio.addEventListener('loadedmetadata', async () => { 
                if (typeof remoteAudio.sinkId !== 'undefined') {
                    try {
                        log.info('LEGO [onTrackAddedEvent] sinkId trying to apply: '+ this.spAudioOutput().deviceId);
                        await remoteAudio.setSinkId(this.spAudioOutput().deviceId);
                        log.info('LEGO [onTrackAddedEvent] sinkId applied: '+ this.spAudioOutput().deviceId);
                    } catch (e) {
                        log.warn('LEGO [onTrackAddedEvent] Error using setSinkId: ', e);
                    }
                }
                try {
                    await remoteAudio.play();
                    log.info('[onTrackAddedEvent] RemoteAudio.play() successful');
                } catch (err) {
                    log.error('[onTrackAddedEvent] RemoteAudio.play() failed:', err);
                }                
             });
            remoteAudio.srcObject = remoteAudioStream; 
        } else {
            log.error('[onTrackAddedEvent] NO RemoteAudioStream Tracks')
        }
    }

    // General end of Session
    async spTeardownSession() {
        const session = this.sip['SipSession'];
        log.info('LEGO [spTeardownSession] Init ...');
        if(session){
            if(!session.teardownComplete) {
                session.teardownComplete = true;
                // Make sure you have released the microphone
                if (session && session.sessionDescriptionHandler && session.sessionDescriptionHandler.peerConnection) {
                    let pc = session.sessionDescriptionHandler.peerConnection;
                    pc.getSenders().forEach(function (RTCRtpSender) {
                        if (RTCRtpSender.track && RTCRtpSender.track.kind == 'audio') {
                            RTCRtpSender.track.stop();
                        }
                    });
                }
                log.info('LEGO [spTeardownSession] done ...');
            }
        }
    
        // Audio Meters
        if (this.localSoundMeter) {
            this.localSoundMeter.stop();
            this.localSoundMeter = null;
        }
        if (this.remoteSoundMeter) {
            this.remoteSoundMeter.stop();
            this.remoteSoundMeter = null;
        }
        if (this.existAgent()) {
            try {
                log.info('LEGO [spTeardownSession] Unregistering agent...');
                if (this.agent.isRegistered())  
                    await this.agent.registerer.unregister();
            } catch (e) {
                log.warn('LEGO [spTeardownSession] Error during unregister:', e);
            }
            try {
                log.info('LEGO [spTeardownSession] Stopping agent...');
                await this.agent.stop();
            } catch (e) {
                log.warn('LEGO [spTeardownSession] Error during agent stop:', e);
            }
        }
    }

    async spAsteriskEndCall() {
        log.info('LEGO [spEndCall] Ending call ');
        let session = this.sip['SipSession'];
        if (session){
            session.data.terminateby = 'us';
            session.data.reasonCode = 16;
            session.data.reasonText = 'Normal Call clearing';
            await session.bye();
        }
        await this.spTeardownSession();
        await this.spCleanLocalCall();
        this.destroyRemoteAudio();
        navigator.mediaDevices.removeEventListener('devicechange', this.spOnDeviceChange);
    }

    destroyRemoteAudio() {
        const audio =  $('#remote-audio').get(0);
        if (!audio) return;
        try {
            audio.pause();
            if (audio.srcObject) {
                audio.srcObject.getTracks().forEach(track => track.stop());
                audio.srcObject = null;
            }
            audio.removeAttribute('src');
            audio.load();
            audio.remove();
    
            log.info('LEGO [destroyRemoteAudio] Elemento <audio> destruido correctamente');
        } catch (err) {
            log.warn('LEGO [destroyRemoteAudio] Error limpiando el audio:', err);
        }
    }

    /**
     * Mute the local microphone on the session
     */
    async spMuteMic(mute: boolean) {
        log.info('LEGO [spMuteMic] mute status: ', mute);
        let isMute = !mute; //-- switch the value - false =disable & true = enable
        let session = this.$store.state.CallsStore.sip.session;
        if (this.sip == null || session == null) return;
    
        var pc = session.sessionDescriptionHandler.peerConnection;
        pc.getSenders().forEach((RTCRtpSender) => {
            if (RTCRtpSender.track && RTCRtpSender.track.kind === 'audio') {
                log.info('LEGO [spMuteMic] Muting Audio Track: ', RTCRtpSender.track);
                RTCRtpSender.track.enabled = isMute;
            }
        });
    
        if (!session.data.mute) session.data.mute = [];
        session.data.mute.push({
            event: (mute ? 'mute' : 'unmute'),
            eventTime: moment().utc().format('YYYY-MM-DD HH:mm:ss UTC')
        });
        session.data.ismute = mute;
    }

    /**
     * Change the Audio Input Device (Ej: mic to internal mic)
     * @param newid
     */
    async spChangeLocalAudioInputDevice(newDevice: any): Promise<void> {
        // Stop Monitoring
        let newId = newDevice.deviceId;
        let session = this.$store.state.CallsStore.sip.session;
        if(!session) return;
        session.data.AudioSourceDevice = newId;
        let constraints = {
            audio: { deviceId: (newId != 'default')? { exact: newId } : 'default' },
            video: false
        };
        try {
            const newStream = await navigator.mediaDevices.getUserMedia(constraints);
            // Assume that since we are selecting from a dropdown, this is possible
            let newMediaTrack = newStream.getAudioTracks()[0];
            let pc = session.sessionDescriptionHandler.peerConnection;
            pc.getSenders().forEach(async (RTCRtpSender) => {
                if(RTCRtpSender.track && RTCRtpSender.track.kind == 'audio') {
                    log.info('LEGO [changeLocalAudioInputDevice] Switching Audio Track : ['+ RTCRtpSender.track.label + '] to [' + newMediaTrack.label + ']');
                    RTCRtpSender.track.stop(); // Must stop, or this mic will stay in use
                    try {
                        await RTCRtpSender.replaceTrack(newMediaTrack);
                        RTCRtpSender.track.enabled = !session.data.ismute;

                        //-- Update store
                        log.info('LEGO [changeLocalAudioInputDevice] Changing Audio Track : ['+ newDevice.deviceId + ']['+ newDevice.label + ']');
                        this.spSetAudioSrc(newDevice);

                        //-- Update monitoring
                        const local = await StartLocalMonitoring(session);
                        if (this.localSoundMeter) {
                            await this.localSoundMeter.stop();
                            this.localSoundMeter = local;
                        } else {
                            this.localSoundMeter = local;
                        }
                    } catch (e) {
                        log.warn('LEGO [changeLocalAudioInputDevice] Error replacing track: ', newId, e);
                    }
                }
            });
        } catch (e) {
            log.warn('LEGO [changeLocalAudioInputDevice] Error on getUserMedia: ', e);
        }
    }

    /**
     * Change the speaker source
     * @param newid
     */
    async spChangeLocalAudioOutputDevice(newDevice: any): Promise<void> {
        let newId = newDevice.deviceId;
        let session = this.$store.state.CallsStore.sip.session;
        if(!session) return;
        session.data.AudioOutputDevice = newId;
        let sinkId = newId;
        log.info('LEGO [spChangeLocalAudioOutputDevice] Attempting to set Audio Output SinkID  [' + sinkId + ']');

        // Remote Audio
        let element = $('#remote-audio').get(0);
        if(element) {
            if (typeof element.sinkId !== 'undefined') {
                try {
                    await element.setSinkId(sinkId);
                    log.log('LEGO [spChangeLocalAudioOutputDevice]  sinkId applied: '+ sinkId);
                    this.spSetAudioOutput(newDevice);
                    const remote = await StartRemoteMonitoring(session);
                    if (this.remoteSoundMeter) {
                        await this.remoteSoundMeter.stop();
                        this.remoteSoundMeter = remote;
                    } else {
                        this.remoteSoundMeter = remote;
                }
                } catch(e){
                    log.warn('LEGO [spChangeLocalAudioOutputDevice]  Error using setSinkId: ', e);
                }
            } else {
                log.warn('LEGO [spChangeLocalAudioOutputDevice] setSinkId() is not possible using this browser.')
            }
        }
    }

    async spOnSessionReceivedBye(response: any) {
        // They Ended the call
        log.info('LEGO [spOnSessionReceivedBye] Call ended, bye! ', response);
        let session = this.sip['SipSession'];
        if (session) {
            session.data.terminateby = 'them';
            session.data.reasonCode = 16;
            session.data.reasonText = 'Normal Call clearing';
            await response.accept();
        }
        try {
            await this.spTeardownSession();
            await this.spCleanLocalCall();
        } catch (error) {
            log.warn('LEGO [spOnSessionReceivedBye] Error during teardown or cleanup:', error);
        }
    }

    spOnSessionReinvited(response){
        log.info('LEGO [spOnSessionReinvited] Init ...', response);

        let session = this.sip['SipSession'];
        // This may be used to include video streams
        var sdp = response.body;

        // All the possible streams will get
        // Note, this will probably happen after the streams are added
        session.data.videoChannelNames = [];
        let videoSections = sdp.split('m=video');
        if(videoSections.length >= 1){
            for(let m=0; m<videoSections.length; m++){
                if(videoSections[m].indexOf('a=mid:') > -1 && videoSections[m].indexOf('a=label:') > -1){
                    // We have a label for the media
                    let lines = videoSections[m].split('\r\n');
                    let channel = '';
                    let mid = '';
                    for(var i=0; i<lines.length; i++){
                        if(lines[i].indexOf('a=label:') == 0) {
                            channel = lines[i].replace('a=label:', '');
                        }
                        if(lines[i].indexOf('a=mid:') == 0){
                            mid = lines[i].replace('a=mid:', '');
                        }
                    }
                    session.data.videoChannelNames.push({'mid' : mid, 'channel' : channel });
                }
            }
            log.info('LEGO [spOnSessionReinvited] videoChannelNames:', session.data.videoChannelNames);
        }
    }

    spOnSessionDescriptionHandlerCreated(sdh){
        log.info('LEGO [spOnSessionDescriptionHandlerCreated] Init ...');
        if (sdh) {
            if(sdh.peerConnection){
                sdh.peerConnection.ontrack = (event)=> {
                    this.spOnTrackAddedEvent(event);
                }
                const pc = sdh.peerConnection;
                pc.addEventListener('iceconnectionstatechange', () => {
                    if (pc.iceConnectionState === 'failed') {
                        log.warn('[ICE event] ICE failed — Possible blockage by firewall or NAT.');
                    } else if (pc.iceConnectionState === 'connected' || pc.iceConnectionState === 'completed') {
                        log.info('[ICE event] ICE Negotiation completed successfully.');
                    }
                  });
                
                  pc.addEventListener('icegatheringstatechange', () => {
                    log.info(`[ICE event] Candidate gathering: ${pc.iceGatheringState}`);
                    if (pc.iceGatheringState === 'complete') {
                        log.info('[ICE event] ICE gathering finished.');
                    }
                  });
                
                  pc.addEventListener('icecandidate', (event) => {
                    if (event.candidate) {
                        log.info(`[ICE event] New Candidate: ${event.candidate.candidate}`);
                    } else {
                        log.warn('[ICE event] No more candidates.');
                    }
                  });
                
                  pc.addEventListener('icecandidateerror', (event) => {
                    log.error('[ICE event] Candidate error:', event);
                  });
                
                  pc.addEventListener('connectionstatechange', () => {
                    log.info(`[ICE event]] Connection status: ${pc.connectionState}`);
                    if (pc.connectionState === 'failed' || pc.connectionState === 'disconnected') {
                        log.error('[ICE event] PeerConnection lost connection or failed..', pc.connectionState);
                    }
                  });
            } else{
                log.warn('LEGO [onSessionDescriptionHandler] fired without a peerConnection');
            }
        } else{
            log.warn('LEGO [onSessionDescriptionHandler] fired without a sessionDescriptionHandler');
        }
    }

    spOnSessionReceivedMessage(response){
        log.info('LEGO [spOnSessionReceivedMessage] Init ...');
        let messageType = (response.request.headers['Content-Type'].length >=1)? response.request.headers['Content-Type'][0].parsed : 'Unknown' ;
        if(messageType.indexOf('application/x-asterisk-confbridge-event') > -1){
            // Conference Events JSON
            let msgJson = JSON.parse(response.request.body);
            let session = this.sip['SipSession'];
            if(!session.data.ConfbridgeChannels) session.data.ConfbridgeChannels = [];
            if(!session.data.ConfbridgeEvents) session.data.ConfbridgeEvents = [];

            if(msgJson.type == 'ConfbridgeStart'){
                log.info('LEGO [spOnSessionReceivedMessage] ConfbridgeStart!');
            } else if(msgJson.type == 'ConfbridgeWelcome'){
                log.info('LEGO [spOnSessionReceivedMessage] Welcome to the Asterisk Conference');
                log.info('LEGO [spOnSessionReceivedMessage] Bridge ID:', msgJson.bridge.id);
                log.info('LEGO [spOnSessionReceivedMessage] Bridge Name:', msgJson.bridge.name);
                log.info('LEGO [spOnSessionReceivedMessage] Created at:', msgJson.bridge.creationtime);
                log.info('LEGO [spOnSessionReceivedMessage] Video Mode:', msgJson.bridge.video_mode);

                session.data.ConfbridgeChannels = msgJson.channels; // Write over this
                session.data.ConfbridgeChannels.forEach(function(chan) {
                    // The mute and unmute status doesn't appear to be a realtime state, only what the
                    // startmuted= setting of the default profile is.
                    log.info('LEGO [spOnSessionReceivedMessage] ', chan.caller.name, 'Is in the conference. Muted:', chan.muted, 'Admin:', chan.admin);
                });
            } else if(msgJson.type == 'ConfbridgeJoin'){
                msgJson.channels.forEach(function(chan) {
                    let found = false;
                    session.data.ConfbridgeChannels.forEach(function(existingChan) {
                        if(existingChan.id == chan.id) found = true;
                    });
                    if(!found){
                        session.data.ConfbridgeChannels.push(chan);
                        session.data.ConfbridgeEvents.push({ event: chan.caller.name + ' ('+ chan.caller.number +') joined the conference', eventTime: this.utcDateNow() });
                        log.info('LEGO [spOnSessionReceivedMessage] ', chan.caller.name, 'Joined the conference. Muted: ', chan.muted);
                    }
                });
            } else if(msgJson.type == 'ConfbridgeLeave'){
                msgJson.channels.forEach(function(chan) {
                    session.data.ConfbridgeChannels.forEach(function(existingChan, i) {
                        if(existingChan.id == chan.id){
                            session.data.ConfbridgeChannels.splice(i, 1);
                            log.info('LEGO [spOnSessionReceivedMessage] ',chan.caller.name, 'Left the conference');
                            session.data.ConfbridgeEvents.push({ event: chan.caller.name + ' ('+ chan.caller.number +') left the conference', eventTime: this.utcDateNow() });
                        }
                    });
                });
            } else if(msgJson.type == 'ConfbridgeTalking'){
                log.info('LEGO [spOnSessionReceivedMessage] Handle video container - update ui (Someone is talking)');
            } else if(msgJson.type == 'ConfbridgeMute'){
                msgJson.channels.forEach(function(chan) {
                    session.data.ConfbridgeChannels.forEach(function(existingChan) {
                        if(existingChan.id == chan.id){
                            log.info('LEGO [spOnSessionReceivedMessage] ', existingChan.caller.name, 'is now muted');
                            existingChan.muted = true;
                        }
                    });
                });
            } else if(msgJson.type == 'ConfbridgeUnmute'){
                msgJson.channels.forEach(function(chan) {
                    session.data.ConfbridgeChannels.forEach(function(existingChan) {
                        if(existingChan.id == chan.id){
                            log.info('LEGO [spOnSessionReceivedMessage]', existingChan.caller.name, 'is now unmuted');
                            existingChan.muted = false;
                        }
                    });
                });
            } else if(msgJson.type == 'ConfbridgeEnd'){
                log.info('LEGO [spOnSessionReceivedMessage] The Asterisk Conference has ended, bye!');
            } else {
                log.info('LEGO [spOnSessionReceivedMessage] Unknown Asterisk Conference Event:', msgJson.type, msgJson);
            }
            response.accept();
        } else if(messageType.indexOf('application/x-myphone-confbridge-chat') > -1){
            log.info('LEGO [spOnSessionReceivedMessage] x-myphone-confbridge-chat', response);
            response.accept();
        } else {
            log.warn('LEGO [spOnSessionReceivedMessage] Unknown message type: ', response)
            response.reject();
        }
    }

    /**
     * Check general - we have a current conference
     */
    public isOnCall(){
        return this.$store.state.CallsStore.isOnCall;
    }

    /**
     * Mute 'Local'
     */
    async muteMyMic(): Promise<void> {
        if (this.isTeacher || !this.currentMember.muted || !this.currentMember.wasMuted) {
            try {
                this.spShowProcessing();
                await this.spRefreshCall();
                await this.mute(this.currentUserId, false);
                await this.spMuteMic(this.currentMember.muted);
            } catch (error) {
                this.handleCallError(error);
            } finally {
                this.spHideProcessing();
            }
        } else {
            this.$EdToast.create({
                msg: `${this.$t('common.wasMuted')}`,
                type: TOAST_TYPES.WARNING,
                top: '3rem',
                timeout: 3000
            });
        }
    }

    /**
     * Check
     * @param deviceType
     */
    isDeviceChangeable(deviceType){
        if(deviceType === 'video') {  //--Camera
            return JitsiMeetJS.mediaDevices.isDeviceListAvailable() &&
                JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('input'); // Camera or Mic.
        }else if(deviceType === 'audio') {  //-- Mic
            let isVideoChangeable = JitsiMeetJS.mediaDevices.isDeviceListAvailable() &&
                JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('input'); // Camera or Mic.
            return isVideoChangeable && JitsiMeetJS.mediaDevices.isMultipleAudioInputSupported();
        }else if (deviceType === 'audiooutput'){ //-- Speakers
            return  JitsiMeetJS.mediaDevices.isDeviceListAvailable() &&
                JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('output'); // Mic (Output)
        }
    }

    /**
     * Get info about the users on call in Asterisk
     * @param classId
     */
    async getAsteriskUserInfo(classId: string): Promise<void> {
        const meet = await CallsService.getCallUsers({ meetingId: this.call.meetingId, classId: this.call.classId,});
        this.spSetMeet(meet);
        await this.spUpdateLocalStateFromCache();
    }


    /**
     * Support WebRtc
     */
    isSupportCalls(){
        return supportJitsi();
    }

    /**
     * Get web browser info
     */
    navigatorInfo(){
        return getOS() + ' - ' + browser.getName() + ' - ' + browser.getVersion();
    }

    /**
     * Show Alerts
     * @param body
     * @param typeError
     */
    public showModal(body?, typeError?) {
        let bodyStr = body??this.$i18n.t('meetings.homeMeetings.errorLoading');
        let typeErr = body ? typeError : KEYS.EVENT_TYPES.DANGER;
        if(this.$refs && (this.$refs as any).EdLoading) {
            (this.$refs as any).EdLoading.hide()
        }
        if(this.$EdModal) {
            this.$EdModal.createMessageModal({
                title: this.$i18n.t('meetings.customizeGroups.errorTitle'),
                body: bodyStr,
                type: typeErr
            });
        }
    }

    async endCall(source:string) {
        try {
            this.spShowProcessing();
            let call = await CallsService.getCallById(this.meet.meetingId);

            //-- Close the call if the user is alone on the call
            let closeBack = call && call.meetingId !== 0 && call.channels == 1;
            if (closeBack) {
                log.info('LEGO [endCall] Call server (closeBack).', call);
                await CallsService.endCall(this.meet.meetingId);
            } else {
                log.info('LEGO [endCall] Call server (singleUserEnd).', call);
            }
            if(this.isTeacher){
                log.info('LEGO [endCall] Teacher leave the meeting:', this.$store.state.AuthStore.user.fullName);
                this.$EdSocket.emit(APP_SOCKET_EVENTS.TEACHER_END_CALL_REQUEST, {
                    username: this.$store.state.AuthStore.user.fullName,
                    messageType: APP_SOCKET_MESSAGES_TYPE.END_CALL,
                    content: this.meet.meetingId,
                    topicId: this.meet.classId
                });
            }
            this.createCallCommand({
                commandType: COMMAND_TYPE.HANGUP, 
                userId: this.currentUserId,
                meetingId: this.meet.meetingId, 
                classId: this.meet.classId,
            })

        } catch(err) {
            this.handleCallError(err);
        } finally {
            await this.spAsteriskEndCall()
            this.spHideProcessing();
        }
    }

    /**
     * Send event to the socket
     * @param message
     */
    createCallCommand(message: any) {
        this.$edEventBus.$emit(CALLS_EVENTS.CREATE_CALL_COMMAND, message);
    }

    /**
     * Get call info from cache.
     * @param meetingId
     */
    async currentCall(meetingId){
        let current = {};
        try {
            let tmp:any = await CallsService.getCurrentCall(meetingId);
            if (tmp.data !== undefined){
                current['exists'] = false;
            }else{
                current = tmp;
                current['exists'] = true;
            }
        } catch (error) {
            current['exists'] = false;
        }
        return current;
    }

    //-- Call my own control & teacher control
    async mute(participantId, wasMuted): Promise<void> {
        const found = this.classMembers.find(m => m.id === participantId)
        const commandType = found.muted ? COMMAND_TYPE.UNMUTE : COMMAND_TYPE.MUTE;
        let newMuteValue = !found.muted;
        let data = { commandType, meetingId: this.meet.meetingId, classId: this.meet.classId, userId:  participantId }
    
        try {
            await CallsService.asteriskCommand(data);
        } catch (error) {
            if (this.userIsNotInCall(error)) {
                log.warn('LEGO [mute] User is not in call, resolving gracefully.');
            } else {
                throw error;
            }
        }
    
        try {
            await CallsService.updateCacheUserCall(this.meet.meetingId, {
                classId: this.meet.classId,
                id: participantId,
                muted: newMuteValue,
                kickouted: found.kickouted,
                wasMuted,
            });
            await this.getAsteriskUserInfo(this.call.classId);    
            await this.createCallCommand({
                commandType,
                mute: newMuteValue,
                userId: this.currentUserId,
                muteUserId: participantId,
            });
        } catch (error) {
            this.handleCallError(error);
        }
    }

    /**
     * Mute user - just update storage & mute device
     * @param participantId
     * @param comm
     */
    async muteLocalClient(participantId, muted){
        this.$store.commit(_CALLS_STORE.MUTATIONS.MUTE_LOCAL, {participantId, muted});
        return await this.spUpdateLocalStateFromCache();
    }

    /**
     * Get the current call from cache and put on localStore
     * then update the controls base on the data.
     */
    async spRefreshCall(): Promise<void> {
        try {
            //-- Get info meeting from cache
            const meet = await this.currentCall(this.meet.meetingId);
            this.spSetMeet(meet);
            await this.spUpdateLocalStateFromCache();    
            this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED, this.currentUserId);
        } catch (error) {
            log.error('LEGO [spRefreshCall] Error refreshing call:', error);
            throw error;
        }
    }

    spShowProcessing(){
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_PROCESSING, true);
    }

    spHideProcessing(){
        this.$store.commit(_CALLS_STORE.MUTATIONS.UPDATE_PROCESSING, false);
    }

    userIsNotInCall(e){
        let onCall = false;
        if (e && e.error === 'BAD_REQUEST' && e.errors){
            e.errors.forEach(el => {
                if(el.status === this.USER_NOT_IN_CALL) onCall = true;
            });
        }
        return onCall
    }

    handleCallError(e){
        log.error('LEGO [handleCallError] ', e)
        if (!e){
            this.showModal(this.$i18n.t('errors.sipGeneralError') , KEYS.EVENT_TYPES.DANGER);
        }else{
            let message = e.message ?? (e.data ? e.data.message : e.toString());
            if(message.includes(this.SIP_ERROR)) {
                if (message.lastIndexOf('Exception:')!=-1) {
                    message = message.substring(message.lastIndexOf('Exception:') + 11, message.length)
                }else{
                    message = message.substring(this.SIP_ERROR.length, message.length)
                }
            }
            this.showModal(this.$i18n.t('errors.sipError') + ' ( ' + message + ' )', KEYS.EVENT_TYPES.DANGER);
        }
    }
}
